import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "underline",
  "use": "underline-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"underline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 1.333c.368 0 .667.299.667.667v4.667a3.333 3.333 0 106.666 0V2a.667.667 0 111.334 0v4.667a4.667 4.667 0 01-9.334 0V2c0-.368.299-.667.667-.667zM2 14c0-.368.298-.667.667-.667h10.666a.667.667 0 010 1.334H2.667A.667.667 0 012 14z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol